export type WsOut =
  | { kind: "user_message"; text: string }
  | { kind: "abort" }
  | { kind: "clear" };

export type WsIn =
  | { kind: "triage"; triageInfo: string | null; triageAnalysis: string | null }
  | { kind: "user_echo"; text: string }
  | { kind: "text_delta"; text: string }
  | { kind: "text"; text: string }
  | { kind: "tool_start"; name: string; args: unknown }
  | { kind: "tool_end"; name: string; durationMs: number; isError: boolean }
  | {
      kind: "turn_complete";
      turn: number;
      inputTokens: number;
      outputTokens: number;
    }
  | {
      kind: "loop_done";
      inputTokens: number;
      outputTokens: number;
      turns: number;
    }
  | { kind: "cleared" }
  | { kind: "history_start" }
  | { kind: "history_end" }
  | { kind: "error"; message: string };

declare const __API_URL__: string;

/** WS URL to use. In dev (no __API_URL__), same-origin via Vite proxy.
 *  In prod, derive ws(s):// from the API base set at build time. */
function wsBaseUrl(): string {
  const apiBase = typeof __API_URL__ !== "undefined" ? __API_URL__ : "";
  if (!apiBase) {
    const proto = location.protocol === "https:" ? "wss:" : "ws:";
    return `${proto}//${location.host}`;
  }
  // Convert https://api.exegesis.example.com → wss://api.exegesis.example.com
  return apiBase.replace(/^http(s?):\/\//, "ws$1://");
}

export function connectSession(
  sessionId: string,
  onFrame: (f: WsIn) => void,
): { send: (f: WsOut) => void; close: () => void } {
  const ws = new WebSocket(`${wsBaseUrl()}/ws/${sessionId}`);
  ws.addEventListener("message", (ev) => {
    try {
      onFrame(JSON.parse(ev.data));
    } catch {
      /* ignore malformed */
    }
  });
  return {
    send(f) {
      if (ws.readyState === ws.OPEN) ws.send(JSON.stringify(f));
    },
    close() {
      ws.close();
    },
  };
}
